export enum AddToCartResponseErrorType {
    CART_FULL = 'CART_FULL',
    CART_FULL_MERGE_ALLOWED = 'CART_FULL_MERGE_ALLOWED',
    GENERIC = 'GENERIC',
    PARTS_NOT_AVAILABLE = 'PARTS_NOT_AVAILABLE',
    UNAUTHORIZED = 'UNAUTHORIZED',
}

export interface CurrencyPricing {
    currency: string;
    currency_price: string;
}

export interface TieredPricing {
    price: string;
    price_list: [CurrencyPricing];
    range_from: number;
    range_to: number;
}

export interface AddToCartChangeEventDetail {
    ti_gpn: string;
    ti_opn: string;
}

export interface AddToCartErrorPlaceHolderMap {
    [placeHolderKey: string]: string
}

export interface AddToCartEntriesResponse {
    opnId: string;
    status: string;
    statusCode: string;
    message: string;
}
export interface AddToCartResponse {
    cartId: string;
    statusType: string;
    statusCode: string;
    message: string;
    errorType: string;
    placeholderMap: AddToCartErrorPlaceHolderMap;
    cartResponsetList: AddToCartEntriesResponse[];
}
